import { FC } from "react";
import { Container } from "react-bootstrap";
import DiscoverJourney from "../Shared/RegionalPages/DiscoverJourney";
import DrivingTogether from "../Shared/RegionalPages/DrivingTogether";
import EmployeeLoves from "../Shared/RegionalPages/EmployeeLoves";
import Stories from "../Shared/RegionalPages/Stories";
import Testimonial from "../Shared/RegionalPages/Testimonial";
import { AMERCIAS_KEY } from "../../utils/_active_regions";
import GreatPlaceToWork from "../Shared/Common/GreatPlaceToWork";

import {
  AMERICAS_DRIVING_TOGETHER,
  AMERICAS_TESTIMONIALS,
  AMERICAS_JOURNEY,
  AMERICAS_STORY,
  AMERICAS_BADGES,
} from "./_static";

import banner_1 from "../../assets/images/americas/banner_1.webp";
import banner_2 from "../../assets/images/americas/banner_2.webp";
import banner_3 from "../../assets/images/americas/banner_3.webp";
import banner_4 from "../../assets/images/americas/banner_4.webp";
import banner_5 from "../../assets/images/americas/banner_5.webp";
import banner_6 from "../../assets/images/americas/banner_6.webp";
import ImageTile from "../Shared/Banner/RegionalBanner/ImageTile";
const images = [banner_1, banner_2, banner_3, banner_4, banner_5, banner_6];

const Americas: FC = () => {
  return (
    <>
      <ImageTile images={images} region={AMERCIAS_KEY} />
      {/* <GreatPlaceToWork items={AMERICAS_BADGES} /> */}
      <Container>
        <div id="discover-journey">
          <DiscoverJourney {...AMERICAS_JOURNEY} />
        </div>
        <DrivingTogether {...AMERICAS_DRIVING_TOGETHER} />
        <EmployeeLoves region={AMERCIAS_KEY} />
        <Stories {...AMERICAS_STORY} />
      </Container>
      <Testimonial items={AMERICAS_TESTIMONIALS} />
    </>
  );
};
export default Americas;
